export default __webpack_public_path__ + "media/sapphire-package-video-calling.a4f36bf05419be2cbc2d137c7b856190.jpeg";